import type { AreaListItem, MonitoringState } from '@tww/shared';
import { AREA_STATUS_LABELS, AREA_STATUS_PILL, mapsUrl, seasonLabel } from '@tww/shared';
import { StatusPill } from '../../ui/basics';
import { Icon } from '../../ui/Icon';

/** Monitoring-Zustand für Listen; gesicherte Flächen und Flächen ohne Pflanzung zeigen nichts (der Flächenstatus sagt es schon) */
export function MonitoringPill({ m }: { m: MonitoringState }) {
  if (m.kind === 'secured' || m.kind === 'none') return <span className="mut">–</span>;
  const cls = m.kind === 'overdue' ? 'offen' : 'abstimmung';
  return <StatusPill code={`${cls} mon-pill`} label={m.label} />;
}
export function AreaStatusPill({ status }: { status: AreaListItem['status'] }) {
  return <StatusPill code={AREA_STATUS_PILL[status]} label={AREA_STATUS_LABELS[status]} />;
}
export function MapsLink({ lat, lng, label = 'In Google Maps öffnen', compact }: { lat: number | null; lng: number | null; label?: string; compact?: boolean }) {
  if (lat == null || lng == null) return null;
  if (compact)
    return (
      <a className="icon-btn" href={mapsUrl(lat, lng)} target="_blank" rel="noreferrer" title={label} aria-label={label} onClick={(e) => e.stopPropagation()}>
        <Icon name="map" />
      </a>
    );
  return (
    <a className="btn sm" href={mapsUrl(lat, lng)} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>
      <Icon name="external" /> {label}
    </a>
  );
}
/** Pflanzsaison ausgeschrieben („Frühjahr 2018“), ohne Pflanzjahr „–“ */
export const plantingLabel = (a: { planting_season_code: string | null; planting_year: number | null }) => (a.planting_year ? seasonLabel(a.planting_season_code, a.planting_year) : '–');
